import { render, staticRenderFns } from "./MyInspectionsLoader.vue?vue&type=template&id=38b62047&"
import script from "./MyInspectionsLoader.vue?vue&type=script&lang=js&"
export * from "./MyInspectionsLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports